interface Operator {
  id: string;
  code: string;
  name: string;
  email?: string;
  priceHour: number;
  operatorType: OperatorType;
  active: boolean;
  annualVacationDays?: number;
  specialityIds: string[];
  operatorRoleIds: string[];
  capabilities: string[];
}

export enum OperatorType {
  Maintenance,
  Production,
  Quality,
  Repairs,
  Assembly,
}

export default Operator;
